import { cn } from "@/lib/utils";

export const PageContainer = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <div className={cn("flex h-full min-h-0 w-full max-w-[1540px] flex-1 flex-col animate-fade-in mx-auto", className)}>
      {children}
    </div>
  );
};
